// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__Jb-pQ","closeModalIcon":"PopUpModal_closeModalIcon__W1x9n"};